import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import api from "@/lib/api";
import { applyTitleFont, applyAccentColor } from "@/hooks/useSiteTexts";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Preloader from "@/components/Preloader";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import Biens from "@/pages/Biens";
import PropertyDetail from "@/pages/PropertyDetail";
import Vendre from "@/pages/Vendre";
import Acheter from "@/pages/Acheter";
import Neufs from "@/pages/Neufs";
import Agence from "@/pages/Agence";
import Conseils from "@/pages/Conseils";
import Admin from "@/pages/Admin";

const FontLoader = () => {
  useEffect(() => {
    api
      .get("/texts")
      .then((r) => {
        if (r.data?.font_titles) applyTitleFont(r.data.font_titles);
        if (r.data?.accent_color) applyAccentColor(r.data.accent_color);
      })
      .catch(() => {});
  }, []);
  return null;
};

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Layout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
    <WhatsAppButton />
  </>
);

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollTop />
        <Preloader />
        <div className="min-h-screen bg-sand font-sans text-slate-900">
          <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/biens" element={<Layout><Biens /></Layout>} />
            <Route path="/biens/:id" element={<Layout><PropertyDetail /></Layout>} />
            <Route path="/vendre" element={<Layout><Vendre /></Layout>} />
            <Route path="/acheter" element={<Layout><Acheter /></Layout>} />
            <Route path="/programmes-neufs" element={<Layout><Neufs /></Layout>} />
            <Route path="/agence" element={<Layout><Agence /></Layout>} />
            <Route path="/conseils" element={<Layout><Conseils /></Layout>} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}
